import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    title: 'heading-s-bold mb-2',
    text: 'heading-s line-clamp-2'
  }
});
